// extracted by mini-css-extract-plugin
export var buttons = "_5z-0";
export var buttonsActive = "_5z-h";
export var cancelConfirm = "_5z-1";
export var closeButton = "_5z-2";
export var column = "_5z-3";
export var container = "_5z-4";
export var detailHeader = "_5z-6";
export var detailTitle = "_5z-7";
export var detailsContent = "_5z-5";
export var header = "_5z-8";
export var headerWithClose = "_5z-9";
export var icon = "_5z-a";
export var infoIcon = "_5z-c";
export var informationContainer = "_5z-b";
export var sideDrawer = "_5z-d";
export var sideDrawerOpen = "_5z-e";
export var stickyFooter = "_5z-f";
export var typeOption = "_5z-g";